import { render, staticRenderFns } from "./ChatMemberMenu.vue?vue&type=template&id=69021dc4&"
import script from "./ChatMemberMenu.vue?vue&type=script&lang=js&"
export * from "./ChatMemberMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports